import { Form, Radio } from '@arco-design/web-react'
import SettingSectionCard from '../SettingSectionCard'
import InstantSwitch from '../InstantSwitch'
import JsonListInput from '../JsonListInput'
import type { OptionsAPI } from '../useOptions'

const KEYS = [
  'fetch_setting.enable_ssrf_protection',
  'fetch_setting.allow_private_ip',
  'fetch_setting.domain_filter_mode',
  'fetch_setting.ip_filter_mode',
  'fetch_setting.domain_list',
  'fetch_setting.ip_list',
  'fetch_setting.allowed_ports',
  'fetch_setting.apply_ip_filter_for_domain',
]

export default function SSRFSection({ options }: { options: OptionsAPI }) {
  const { get, getBool, patch } = options

  return (
    <SettingSectionCard title="SSRF 防护" subtitle="服务器端请求伪造防护，保护内网资源" keys={KEYS} options={options}>
      <Form layout="vertical">
        <div className="grid md:grid-cols-2 gap-3">
          <Form.Item label="启用 SSRF 防护">
            <InstantSwitch options={options} optionKey="fetch_setting.enable_ssrf_protection" defaultChecked />
          </Form.Item>
          <Form.Item label="允许访问私有 IP">
            <InstantSwitch options={options} optionKey="fetch_setting.allow_private_ip" />
          </Form.Item>
          <Form.Item label="对域名启用 IP 过滤">
            <InstantSwitch options={options} optionKey="fetch_setting.apply_ip_filter_for_domain" defaultChecked />
          </Form.Item>
        </div>

        <Form.Item label="域名过滤模式">
          <Radio.Group
            value={getBool('fetch_setting.domain_filter_mode', true) ? 'whitelist' : 'blacklist'}
            onChange={(v) => patch({ 'fetch_setting.domain_filter_mode': v === 'whitelist' })}
            type="button"
          >
            <Radio value="whitelist">白名单</Radio>
            <Radio value="blacklist">黑名单</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="域名列表" extra="支持通配符，如 example.com, *.api.example.com">
          <JsonListInput
            value={get('fetch_setting.domain_list', '[]')}
            onChange={(v) => patch({ 'fetch_setting.domain_list': v })}
            placeholder="输入域名后回车"
          />
        </Form.Item>

        <Form.Item label="IP 过滤模式">
          <Radio.Group
            value={getBool('fetch_setting.ip_filter_mode', true) ? 'whitelist' : 'blacklist'}
            onChange={(v) => patch({ 'fetch_setting.ip_filter_mode': v === 'whitelist' })}
            type="button"
          >
            <Radio value="whitelist">白名单</Radio>
            <Radio value="blacklist">黑名单</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="IP 列表" extra="支持 CIDR，如 8.8.8.8, 192.168.1.0/24">
          <JsonListInput
            value={get('fetch_setting.ip_list', '[]')}
            onChange={(v) => patch({ 'fetch_setting.ip_list': v })}
            placeholder="输入 IP 后回车"
          />
        </Form.Item>

        <Form.Item label="允许的端口" extra="如 80, 443, 8000-8999">
          <JsonListInput
            value={get('fetch_setting.allowed_ports', '["80","443","8080","8443"]')}
            onChange={(v) => patch({ 'fetch_setting.allowed_ports': v })}
            placeholder="输入端口后回车"
          />
        </Form.Item>
      </Form>
    </SettingSectionCard>
  )
}
